import {ref} from 'vue';
import {defineStore} from 'pinia';
import {readonlyState} from '@malt/utils';
import {FetchError} from '@api';
import type {ShortlistResponse} from '@api';
import {useApis} from '~/composables';

export const useShortlistStore = defineStore('shortlist', () => {
    const {shortlistApi} = useApis();

    const shortlist = ref<ShortlistResponse>();

    async function fetchShortlist() {
        try {
            shortlist.value = await shortlistApi.retrieveShortlist();
        } catch (error) {
            if (error instanceof FetchError) {
                shortlist.value = undefined;
            }
        }
    }

    async function remove(profileId: string) {
        await shortlistApi.removeProfileFromShortlist({profileId});
        await fetchShortlist();
    }

    async function deleteShortlist() {
        await shortlistApi.deleteShortlist();
        await fetchShortlist();
    }

    function isInShortlist(profileId: string): boolean {
        return shortlist.value?.profiles.some((profile) => profile.profileId === profileId) ?? false;
    }

    return {
        shortlist: readonlyState(shortlist),
        fetchShortlist,
        remove,
        deleteShortlist,
        isInShortlist,
    };
});
